import { ADD_NEW_DEBARRED, GET_ALL_DEBARRED_DATA, UPDATE_DEBARRED } from "../../../common/constants/endpoints";
import { toastr } from "react-redux-toastr";
import API from '../../../helpers/API'
import { ALL_DEBAR_USERS_DATA } from "./debarActionTypes";


export const addDebarUser = (data, setAddDebarModal) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        try {
            const response = await API.post(ADD_NEW_DEBARRED, data, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getAllDebarUsers(0, 10));
            toastr.success(response.data.message);
            if (response) {
                setAddDebarModal(false)
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ? error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    }
}

export const getAllDebarUsers = (pageNumber, rowPerPage) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        try {
            const response = await API.get(GET_ALL_DEBARRED_DATA + `/${pageNumber}` + `/${rowPerPage}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            dispatch({
                type: ALL_DEBAR_USERS_DATA,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ? error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
}

export const updateDebarUser = (data, setUpdateDebarModal) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        try {
            const response = await API.post(UPDATE_DEBARRED, data, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch(getAllDebarUsers(0, 10));
            toastr.success(response.data.message);
            if (response) {
                setUpdateDebarModal(false)
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ? error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    }
}